import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import { urlCode, urlCodeSecured, urlGetAllCodeSecured } from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_CODE,
  GET_CODE,
  UPDATE_CODE,
  DELETE_CODE,
  FILTER_CODE,
} from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.batch !== undefined) filter += "&batch=" + filters.batch;
    if (filters.culture !== undefined) filter += "&culture=" + filters.culture;
    if (filters.varietyUuid !== undefined)
      filter += "&varietyUuid=" + filters.varietyUuid;
    if (filters.articleUuid !== undefined)
      filter += "&articleUuid=" + filters.articleUuid;
    if (filters.sectorUuid !== undefined)
      filter += "&sectorUuid=" + filters.sectorUuid;
    if (filters.code !== undefined) filter += "&code=" + filters.code;
    if (filters.status !== undefined) filter += "&status=" + filters.status;
    if (filters.locationUuid !== undefined)
      filter += "&locationUuid=" + filters.locationUuid;
    if (filters.viveroUuid !== undefined)
      filter += "&viveroUuid=" + filters.viveroUuid;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Get Code by uuid.
 */
export const getCodeByUuid = createAction(GET_CODE, (param) =>
  apiGet(urlCodeSecured, param, true)()
);

/**
 * Filter list Code.
 */
export const filterCode = createAction(FILTER_CODE, (filter, param) =>
  apiGet(urlCodeSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Filter list Code.
 */
export const listAll = createAction("LIST_ALL", () =>
  apiGet(urlGetAllCodeSecured, undefined, true)()
);

/**
 * Create Code.
 */
export const createCode = createAction(CREATE_CODE, (obj) =>
  apiPost(urlCodeSecured, obj, undefined, true)()
);

/**
 * Update Code.
 */
export const modifyCode = createAction(UPDATE_CODE, (obj, param) =>
  apiPut(urlCodeSecured, obj, param, true)()
);

/**
 * Delete Code by uuid.
 */
export const removeCode = createAction(DELETE_CODE, (param) =>
  apiDelete(urlCodeSecured, param, true)()
);
